import { useOnClickOutside } from '../../../hooks/dom'
import LocationPickerItems from './location-picker-items'
import {
    LocationPickerCommonProps,
    LocationPickerExclusiveProps,
    LocationPickerRenderedComponentAddedProps,
    LocationPickerPassThroughProps,
} from './types'

type Props<T extends object> = LocationPickerPassThroughProps &
    LocationPickerCommonProps<T> &
    LocationPickerRenderedComponentAddedProps<T> & {
        component: LocationPickerExclusiveProps<T>['widgetComponent']
        [prop: string]: unknown
    }

const Widget = <T extends object = object>({
    component: Component,
    isOpen,
    onOpen,
    onClose,
    ...restProps
}: Props<T>) => {
    const { ref: _widgetInputContainerRef } = useOnClickOutside(onClose)

    return (
        <Component {...restProps} isOpen={isOpen} onOpen={onOpen} onClose={onClose} inputRef={_widgetInputContainerRef}>
            <LocationPickerItems {...(restProps as any)} />
        </Component>
    )
}

export default Widget
